import { heroImage, type LandingPage } from "@/lib/data/landing/types"

// Replaced /croissants on 2026-10-29, when Toast dropped single croissants and
// salt bread took over the pastry case (/croissants now 308s here). There is
// no croissant dozen either (Aya, 2026-10-30), so croissants appear only in
// the FAQ, for people who land here from an old /croissants link.
//
// TODO(photo): MIU in-house shoot needed for the salt breads Toast has no photo
// for: Almond, Pistachio Chocolate, Chocolate, Triple Chocolate, Creme Brulee,
// Blueberry Cream Cheese, Strawberry Custard, Corn Cheese, the four salt bread
// sandwiches. Upload the photo to the item in
// Toast and re-run apps/backend/scripts/sync-toast-menu-images-to-r2.mjs.
export const SALT_BREAD_PAGE: LandingPage = {
  path: "/salt-bread",
  breadcrumb: "Salt Bread",
  title: "Salt Bread in Rancho Cucamonga | +Bake Cafe",
  description:
    "Double ube, pandan kaya, garlic cream cheese and Japanese sausage salt bread, plus $4.95 salt bread sandwiches, at +Bake Cafe on Base Line Rd, Rancho Cucamonga.",
  eyebrow: "The pastry case",
  h1: "Salt Bread at +Bake Cafe, Rancho Cucamonga",
  intro:
    "The pastry case at +Bake now runs on salt bread: a soft roll baked around butter and finished with flaky salt, in sweet and savory flavors. Butter salt bread is $2.95, most flavors are $3.95, and the salt bread sandwiches are $4.95. Stop by 8685 Base Line Rd any day from 7:30 AM, or order ahead on Toast and pick up on your way to work.",
  hero: heroImage(
    "salt-bread-assortment-hero",
    "Assorted +Bake salt bread on a cooling rack: garlic cream cheese, Japanese sausage, chocolate, pistachio and almond",
  ),
  trackingLocation: "salt_bread_page",
  sections: [
    {
      id: "sweet",
      heading: "Sweet salt bread",
      paragraphs: [
        "Nine sweet flavors, all $3.95. Ube and pandan come from the same Southeast Asian pantry as the rest of the +Bake menu; kaya is a coconut jam that pairs naturally with pandan. The rest lean on chocolate, custard and cream cheese.",
      ],
      items: [
        { name: "Double Ube Salt Bread" },
        { name: "Pandan Kaya Salt Bread" },
        { name: "Almond Salt Bread" },
        { name: "Pistachio Chocolate Salt Bread" },
        { name: "Chocolate Salt Bread" },
        { name: "Triple Chocolate Salt Bread" },
        { name: "Creme Brulee Salt Bread", label: "Crème Brûlée Salt Bread" },
        { name: "Blueberry Cream Cheese Salt Bread" },
        { name: "Strawberry Custard Salt Bread" },
      ],
    },
    {
      id: "savory",
      heading: "Savory salt bread",
      paragraphs: [
        "Start with the plain butter salt bread if it's your first one; it's the base every other flavor builds on. Garlic cream cheese and Japanese sausage are the savory picks. Toast also lists two-for prices on the butter ($5.50 for two) and beef ($7.50 for two) salt bread.",
      ],
      items: [
        { name: "Butter Salt Bread" },
        { name: "Garlic Cream Cheese Salt Bread" },
        { name: "Japanese Sausage Salt Bread" },
        { name: "Beef Salt Bread" },
        { name: "Corn Cheese Salt Bread" },
      ],
    },
    {
      id: "sandwiches",
      heading: "Salt bread sandwiches",
      paragraphs: [
        "Four sandwiches on salt bread sit in the grab-and-go case, all $4.95. They're the quickest lunch in the building: pick one up at the counter with no wait on the kitchen.",
      ],
      items: [
        { name: "Turkey Provolone Salt Bread" },
        { name: "Chicken Caprese Salt Bread" },
        { name: "Bacon Egg Potato Salad Salt Bread" },
        { name: "Ham and Egg Salt Bread", label: "Ham & Egg Salt Bread" },
      ],
    },
    {
      id: "pair-it",
      heading: "Pair it",
      paragraphs: [
        "Butter and salt want a drink with some milk or some bitterness. Three that work with anything in the case:",
      ],
      items: [{ name: "Pandan Latte" }, { name: "Strawberry Matcha Latte" }, { name: "Cortado" }],
      links: [
        { label: "Our coffee program", to: "coffee" },
        { label: "The matcha menu", to: "matcha" },
      ],
    },
  ],
  faq: [
    {
      q: "What is salt bread?",
      a: "A soft roll baked around butter and finished with flaky salt, so the outside turns golden and the bottom bakes crisp. It's also called shio pan. At +Bake it comes plain, sweet and savory, and as sandwiches.",
    },
    {
      q: "Do you still sell croissants?",
      a: "No. Salt bread replaced croissants in the pastry case in October 2026. If you liked the garlic cream cheese croissant, try the garlic cream cheese salt bread.",
    },
    {
      q: "What time is salt bread available?",
      a: "From 7:30 AM until close at 3:30 PM daily, while the case lasts. Popular flavors can sell out, so order ahead on Toast to hold yours.",
    },
    {
      q: "Where are you?",
      a: "8685 Base Line Rd, Ste B, in Sunrize Center, Rancho Cucamonga. Free parking in the plaza.",
    },
  ],
}
